import { localForage, localStorage } from './storages'

const PersistedStorages = (key) => {
  localStorage.initialize(key)
  localForage.initialize(key)

  return {
    localStorage: localStorage.getStorage(),
    localForage: localForage.getStorage(),
  }
}

export default PersistedStorages
